import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";

interface WaitlistModalProps {
  open: boolean;
  onClose: () => void;
}

const WaitlistModal = ({ open, onClose }: WaitlistModalProps) => {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-lg bg-card/80 backdrop-blur-xl border-white/10 z-50 p-0 overflow-hidden max-h-[90vh]">
        <VisuallyHidden>
          <DialogTitle>Join the Waitlist</DialogTitle>
          <DialogDescription>Sign up for early access to MedGrowth Radar.</DialogDescription>
        </VisuallyHidden>
        <div className="w-full" style={{ minHeight: 500 }}>
          {open && (
            <iframe
              src="https://api.clinicoffers.net/widget/form/wMwuf7awmbuh6B21YN7a"
              style={{ display: "block", width: "100%", height: 500, border: "none", borderRadius: 3 }}
              title="MedGrowth Radar - Join the Waitlist"
            />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default WaitlistModal;
